<template>
  <van-swipe class="nav-swipe" :loop="false" indicator-color="#999" :width="swipeWidth" :height="navData.length*navData">
    <van-swipe-item v-for="(navSwipe, ns) in navData" :key="ns" :class="'nav-swipe-row-'+lineCount">
      <div class="classification" >
        <div class="nav-row" v-for="(navRow, nr) in navSwipe" :key="nr" >
          <div class="item clickable" v-for="(item, i) in navRow" :key="i"
               @click="goCategoryMore(item)">
            <img class="item-img" :src="item.iconPath" alt="">
            <p class="item-text">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { mapGetters} from 'vuex';
import { listAd, listNav, tipsList } from '@/api/mall/mallContent'
  export default {
  components: {
  },
  computed:{
    ...mapGetters([
      'mallActive'
    ])
  },
  props: {
    reqData: {
      required:false,
      default: {}
    }
  },
  data(){
    return {
      swipeWidth: window.screen.width || 375,
      swipeHeight: (window.screen.width>375) ? 200 : 174,
      navData: [],
      lineCount: 4,// 每行显示个数
    }
  },
  created(){
    this.get_AD_and_Nav() // 获取商品热门推荐
  },
  methods: {
    get_AD_and_Nav() {
      let req = Object.assign({}, this.reqData)
      req.clientType = "H5";
      listNav(req).then(res => { // 获取导航
        this.lineCount = res.data.lineCount || 4;// 每行显示图标个数

        const arr = res.data.navItemlist || []; // icon 源数据
        const a = [], b = [];//缓存数据
        // 分组
        const ii = Math.ceil(arr.length / this.lineCount);
        for (let i = 0; i < ii; i++) {
          a.push(arr.splice(0, this.lineCount))
        }
        //分页
        const kk = Math.ceil(a.length / 2)
        for (let j = 0; j < kk; j++) {
          b.push(a.splice(0, 2))
        }
        this.navData = b;
        // console.log(this.navData)
      })
    },
    goCategoryMore(item){
      console.log(item)

      switch (item.targetType){
        case 1: // 1-知识商品平台类目1级；
        case 2: // 2-知识商品平台类目2级；
        case 3: // 3-知识商品平台类目3级；
          this.session('category', {categoryId: item.targetId, title: item.title, level: item.targetType})
          this.$router.push({name: 'categoryMore'})
          break;
        case 4: // 4-知识店铺；

          break;
        case 5: // 5-知识商品-课程；

          break;
        case 6: // 6-知识商品-专栏；

          break;
        case 7: // 7-知识商品-直播；

          break;
        case 30: // 30-知识店铺列表；
          this.$router.push({name: 'mallShopList'})
          break;
        case 101: // 101-省购商品平台类目1级(targetId为类目ID)；
        case 102: // 102-省购商品平台类目2级(targetId为类目ID)；
        case 103: // 103-省购商品平台类目3级(targetId为类目ID)；
          this.session('category', {categoryId: item.targetId, title: item.title, level: item.targetType})
          this.$router.push({name: 'jdGoodsList'})
          break;
        case 104: // 104-省购店铺(targetId为shopId)；

          break;
        case 105: // 105-省购商品-京东非书商品(targetId为productId)；

          break;
        case 106: // 106-省购商品-京东图书(targetId为productId)；

          break;
        case 110: // 110-京东省购首页(targetId为null)；
          // categoryLevel 顶级分类传空
          this.$store.dispatch('app/change_categorySysId', ['', '', ''])
          // this.$router.push({name: 'sgGoodsList', query: {parentId: item.targetId, categoryLevel: null} })
          this.$router.push({name: 'sgGoodsList', query: {parentId: item.targetId, categoryLevel: null}})
          break;
        case 111: // 111-淘宝省购首页(targetId为null)

          break;
        case 112: // 112-拼多多省购首页(targetId为null)；

          break;
        case 130: // 130-省购店铺首页(targetId为null)；
          if(this.mallActive === 1){
            this.$router.push({name: 'sgShopList'})
          }else if(this.mallActive === 2){
            this.$router.push({name: 'mallShopList'})
          }
          break;
        case 140: // 140-开分销店(targetId为null)
          this.$dialog.confirm({
            title: '提示',
            message: '此功能请在APP中使用，是否前往下载？'
          }).then(() => {
            this.$router.push({name: 'h5Register', query: {inviteUserId: this.session('userOpenId')} })
          }).catch(() => {});
          break;
        case 141: // 141-金币抵扣专区(targetId为null)
          this.$router.push({name: 'sgCoinGoods'})
          break;
        case 142: // 142-营销活动byKey(targetId为活动KEY：SPRING_FESTIVAL-年货专区)
          this.$router.push({name: 'newActivity'})
          break;
        case 200: // 200-签到页(targetId为null)

          break;
        case 201: // 201-赚钱攻略(URL跳转)
          this.$router.push({name: 'moneyStrategy', query: { } })
          break;
        default:
          this.$dialog({
            title: '提示',
            message: '功能开发中，敬请期待！'
          })
          console.error('未定义的跳转类型')
          break;
      }





    },
  }
}
</script>

<style lang="less" scoped>
  .nav-swipe{
    .classification{
      /*height: 174px;*/
      padding: 12px 0;
      width: 100%;
      .nav-row{
        height: 48%;
        display: flex;
        margin-bottom: 12px;
        .item{
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex: 1;
          max-width: 25%;
          .item-img{
            display: block;
            width: 44px;
            height: 44px;
            margin-bottom: 10px;
          }
          .item-text{
            font-size: 12px;
            line-height: 16px;
            color: #2b2b2b;
          }
        }
      }
    }
    .nav-swipe-row-3 .classification .nav-row .item{max-width: 33.3%;}
    .nav-swipe-row-4 .classification .nav-row .item{max-width: 25%;}
    .nav-swipe-row-5 .classification .nav-row .item{max-width: 20%;
      .item-img{width: 44px;height: 44px;}
    }
    .nav-swipe-row-6 .classification .nav-row .item{max-width: 16.6%;
      .item-img{width: 30px;height: 30px;}
    }
  }
</style>